module.exports = __webpack_public_path__ + "img/yhq.48ebaf35.png";